import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NotFoundPage from '../pages/notFound';
import ProtectedRoutes from './ProtectedRoutes';
import { FiltersPage } from '@/pages/filters/Loadable';
import { FilterDetailPage } from '@/pages/filterDetail/Loadable';
import { DashboardPage } from '@/pages/dashboard/Loadable';
import { SignInPage } from '@/pages/auth/sign-in/Loadable';
import { SignUpPage } from '@/pages/auth/sign-up/Loadable';
import ProtectedAuthRoutes from './ProtectedAuthRoutes';
import { SlackPage } from '@/pages/slack/Loadable';
import { DiscordPage } from '@/pages/discord/Loadable';
import AuthCheckingRoutes from './AuthCheckingRoutes';
import { ROUTES } from '@/config/const';
import { SlackDetailPage } from '@/pages/slackDetail/Loadable';
import { DiscordDetailPage } from '@/pages/discordDetail/Loadable';

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedAuthRoutes />}>
          <Route path={ROUTES.login} element={<SignInPage />} />
          <Route path={ROUTES.register} element={<SignUpPage />} />
        </Route>

        <Route path={ROUTES.home} element={<AuthCheckingRoutes />} />

        <Route element={<ProtectedRoutes />}>
          <Route path={ROUTES.dashboard} element={<DashboardPage />} />
          <Route path={ROUTES.filters} element={<FiltersPage />} />
          <Route path={ROUTES.filterDetail} element={<FilterDetailPage />} />
          <Route path={ROUTES.slack} element={<SlackPage />} />
          <Route path={ROUTES.slackDetail} element={<SlackDetailPage />} />
          <Route path={ROUTES.discord} element={<DiscordPage />} />
          <Route path={ROUTES.discordDetail} element={<DiscordDetailPage />} />
        </Route>

        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
